import * as React from "react";

const ExportPDFIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17.664"
    height="19.3"
    viewBox="0 0 17.664 19.3"
    {...props}
  >
    <path
      id="PDF_export"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.3"
      d="M2.635 7.545V1H14.5l2.864 2.864V19H1.818M13.273 1v4.091h4.091m-5.319 10.636V10h3.273m-3.273 2.864H14.5M1 10h1.227c1.636 0 1.841 1.023 1.841 1.636s-.2 1.636-1.841 1.636H1.2v1.636H1Zm5.318 4.909V10h1.395c.93 0 1.878.409 1.878 2.455s-.947 2.455-1.878 2.455Z"
      data-name="PDF export"
      transform="translate(-.35 -.35)"
    />
  </svg>
);

export default ExportPDFIcon;
